export default class Storage {
    static prefix() {
        return process.env.VUE_APP_LOCAL_STORAGE_PREFIX || 'com.atabix_';
    }
    static title(key) {
        return Storage.prefix() + key;
    }
    static get(key) {
        return localStorage.getItem(Storage.title(key));
    }
    static set(key, value) {
        localStorage.setItem(Storage.title(key), value);
    }
    static delete(key) {
        localStorage.removeItem(Storage.title(key));
    }
}
